function validateTextSubmission(textarea) {
  const content = textarea.value.trim();
  const maxLength = 2000;
  return content && content.length <= maxLength;
}

function resetChatForm() {
  const textForm = document.querySelector('.js-chat_widget__form-text');
  if (textForm) {
    textForm.reset();
    const textarea = textForm.querySelector('.js-chat-textarea');
    if (textarea) {
      textarea.style.height = '21px';
      textarea.value = '';
      textarea.style.overflowY = 'hidden';
      const event = new Event('input', { bubbles: true });
      textarea.dispatchEvent(event);
    }
    const sendButton = textForm.querySelector('.js-send-button');
    const clipButton = textForm.querySelector('.js-clip-button');
    if (sendButton) {
      sendButton.classList.add('hidden');
      sendButton.disabled = false;
    }
    if (clipButton) clipButton.classList.remove('hidden');
    const helpTextDefault = document.querySelector('.js-help-text-default');
    const helpTextInput = document.querySelector('.js-help-text-input');
    if (helpTextDefault) helpTextDefault.classList.remove('hidden');
    if (helpTextInput) helpTextInput.classList.add('hidden');
    const errorBox = document.querySelector('.js-chat_widget__form-error');
    if (errorBox) errorBox.classList.add('hidden');
  }
}

function initPublicTextForm() {
  const textForm = document.querySelector('.js-chat_widget__form-text');
  const textarea = textForm?.querySelector('.js-chat-textarea');
  const clipButton = textForm?.querySelector('.js-clip-button');
  const sendButton = textForm?.querySelector('.js-send-button');
  const helpTextDefault = document.querySelector('.js-help-text-default');
  const helpTextInput = document.querySelector('.js-help-text-input');
  const chatBody = document.querySelector('.js-chat_widget__body');

  if (textarea) {
    textarea.addEventListener('input', function() {
      const inputText = this.value.trim();
      const maxLength = 2000;
      const currentLength = inputText.length;
      const isOverLimit = currentLength > maxLength;

      if (inputText) {
        if (clipButton) clipButton.classList.add('hidden');
        if (sendButton) sendButton.classList.remove('hidden');
        if (isOverLimit && sendButton) {
          sendButton.disabled = true;
          const textErrorBox = document.querySelector('.js-chat_widget__form-error');
          if (textErrorBox) {
            textErrorBox.textContent = '2000文字以上のテキストは入力できません。';
            textErrorBox.classList.remove('hidden');
          }
        } else if (sendButton) {
          sendButton.disabled = false;
          const textErrorBox = document.querySelector('.js-chat_widget__form-error');
          if (textErrorBox) textErrorBox.classList.add('hidden');
        }
        if (helpTextDefault) helpTextDefault.classList.add('hidden');
        if (helpTextInput) helpTextInput.classList.remove('hidden');
      } else {
        if (clipButton) clipButton.classList.remove('hidden');
        if (sendButton) sendButton.classList.add('hidden');
        if (helpTextDefault) helpTextDefault.classList.remove('hidden');
        if (helpTextInput) helpTextInput.classList.add('hidden');
      }

      this.style.height = '24px';
      const scrollHeight = this.scrollHeight;
      const lineHeight = 24;
      const maxLines = 7;
      const maxHeight = lineHeight * maxLines;
      if (scrollHeight <= maxHeight) {
        this.style.height = scrollHeight + 'px';
        this.style.overflowY = 'hidden';
      } else {
        this.style.height = maxHeight + 'px';
        this.style.overflowY = 'auto';
      }
    });

    textarea.addEventListener('keydown', function(e) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
        e.preventDefault();
        if (validateTextSubmission(this)) {
          if (textForm) textForm.submit();
        }
      }
    });
  }

  if (textForm) {
    textForm.addEventListener('submit', function(event) {
      if (!validateTextSubmission(textarea)) {
        event.preventDefault();
        return;
      }
      const sendButton = textForm.querySelector('.js-send-button');
      if (sendButton) sendButton.disabled = true;
      setTimeout(function() { resetChatForm(); }, 100);
    });
  }
}

window.initPublicTextForm = initPublicTextForm;